import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import iView from 'iview'
import Toast from './common/utils/toast.js'
import 'element-ui/lib/theme-chalk/index.css'
import { Upload,Steps, Step,Table,TableColumn,Button,Dialog,Link,Form,FormItem,Input } from 'element-ui'
import 'iview/dist/styles/iview.css'
import 'jquery'
Vue.use(Toast)
Vue.use(iView)
Vue.use(Upload);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Link);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.prototype.http = axios
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
